"use strict";

const ADD_USER_TO_GROUP_REQUEST = "ADD_USER_TO_GROUP_REQUEST";
const ADD_USER_TO_GROUP_SUCCESS = "ADD_USER_TO_GROUP_SUCCESS";
const ADD_USER_TO_GROUP_ERROR = "ADD_USER_TO_GROUP_ERROR";
const DELETE_USER_TO_GROUP_REQUEST = "DELETE_USER_TO_GROUP_REQUEST";
const DELETE_USER_TO_GROUP_SUCCESS = "DELETE_USER_TO_GROUP_SUCCESS";
const DELETE_USER_TO_GROUP_ERROR = "DELETE_USER_TO_GROUP_ERROR";
const ALREADY_EXIST_USER_IN_GROUP_SUCCESS = "ALREADY_EXIST_USER_IN_GROUP_SUCCESS";
const ALREADY_EXIST_USER ="Already exist user"
const UPDATE_USER_TO_GROUP_SUCCESS = "UPDATE_USER_TO_GROUP_SUCCESS";
const UPDATE_USER_TO_GROUP_ERROR = "UPDATE_USER_TO_GROUP_ERROR";

export {
  ADD_USER_TO_GROUP_REQUEST,
  ADD_USER_TO_GROUP_SUCCESS,
  ADD_USER_TO_GROUP_ERROR,
  DELETE_USER_TO_GROUP_ERROR,
  DELETE_USER_TO_GROUP_REQUEST,
  DELETE_USER_TO_GROUP_SUCCESS,
  ALREADY_EXIST_USER_IN_GROUP_SUCCESS,
  ALREADY_EXIST_USER,
  UPDATE_USER_TO_GROUP_SUCCESS,
  UPDATE_USER_TO_GROUP_ERROR
};